import { offlineDb } from './offline-db'
import { generateClientUuid } from './uuid'

/**
 * @param {string} clientUuid
 * @param {Object} payload - API body for final submit
 * @returns {Promise<string>} idempotency key
 */
export async function enqueueFinalSync(clientUuid, payload) {
  const idempotencyKey = generateClientUuid()
  await offlineDb.syncQueue.add({
    clientUuid,
    operation: 'final_submit',
    payload,
    idempotencyKey,
    attempts: 0,
    status: 'pending',
    createdAt: new Date().toISOString(),
    nextRetryAt: null
  })
  return idempotencyKey
}

export async function countPendingSync() {
  return offlineDb.syncQueue
    .where('status')
    .anyOf('pending', 'error')
    .count()
}
